const getStaticAssetBaseUrl = () => {
  const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:3003").replace(
    /\/$/,
    ""
  );
  // static files อยู่ที่ root ของ server ไม่ใช่ใต้ /api
  return apiUrl.replace(/\/api$/i, "");
};

export const resolveProfileImageSrc = (image) => {
  if (!image || typeof image !== "string") {
    return undefined;
  }

  const trimmed = image.trim();
  if (!trimmed) {
    return undefined;
  }

  if (
    trimmed.startsWith("data:") ||
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("blob:")
  ) {
    return trimmed;
  }

  if (/^[A-Za-z0-9+/=\s]+$/.test(trimmed) && trimmed.length > 100) {
    return `data:image/jpeg;base64,${trimmed.replace(/\s/g, "")}`;
  }

  const assetBase = getStaticAssetBaseUrl();
  return trimmed.startsWith("/") ? `${assetBase}${trimmed}` : `${assetBase}/${trimmed}`;
};

export const compressProfileImage = (
  file,
  maxWidth = 800,
  maxHeight = 800,
  quality = 0.85
) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = event.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });